import { login, logout, getInfo, refToken, tokenLogin } from "@/api/login";
import store from "@/store";
import {
  getToken,
  setToken,
  removeToken,
  getTokenExpriedMins,
  setTokenExpriedMins,
  getRefreshToken,
  setRefreshToken,
  getRefreshTokenExpriedMins,
  setRefreshTokenExpriedMins,
  getUserInfo,
  setUserInfo,
  removeStorage,
  storeLoginSource
} from "@/utils/auth";
import { signData } from "@/utils/sign-cfg.js";

const user = {
  //namespaced true 需要加前缀
  namespaced: true,
  state: {
    token: getToken() || "",
    tokenExpriedMins: getTokenExpriedMins() || "",
    refreshToken: getRefreshToken() || "",
    refreshTokenExpriedMins: getRefreshTokenExpriedMins() || "",
    userInfo: {
      authUserOrg: [],
      authUser: [],
      authFuncs: [],
      authApps: [],
      orgModel: [],
      authThirdSsoInfo: {}
    },
    userType: "",
    loginSource: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },

    SET_TokenExpriedMins: (state, tokenExpriedMins) => {
      state.tokenExpriedMins = tokenExpriedMins;
    },

    SET_RefreshToken: (state, refreshToken) => {
      state.refreshToken = refreshToken;
    },

    SET_RefreshTokenExpriedMins: (state, refreshTokenExpriedMins) => {
      state.refreshTokenExpriedMins = refreshTokenExpriedMins;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_USER_TYPE: (state, userType) => {
      state.userType = userType;
    },
    SET_LOGIN_SOURCE: (state, loginSource) => {
      state.loginSource = loginSource;
    }
  },

  actions: {
    // 登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        userInfo.appId = store.getters.appCode;
        login(signData(userInfo))
          .then(response => {
            const tokenStr = response.token;
            const tokenExpriedMins = response.invalidTime;
            const refreshToken = response.refreshToken;
            const refreshTokenExpriedMins = response.refreshInvalidTime;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            setTokenExpriedMins(tokenExpriedMins);
            commit("SET_TokenExpriedMins", tokenExpriedMins);
            setRefreshToken(refreshToken);
            commit("SET_RefreshToken", refreshToken);
            setRefreshTokenExpriedMins(refreshTokenExpriedMins);
            commit("SET_RefreshTokenExpriedMins", refreshTokenExpriedMins);
            // let userInfo = {
            //   authOrg: response.authOrg || [],
            //   authUser: response.authUser || [],
            //   authFuncs: response.authFuncs || [],
            //   authApps: response.authApps || [],
            // }
            // setUserInfo(userInfo);
            // commit('SET_USER_INFO', userInfo)    //保存用户的所有信息
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // token登录
    tokenLogin({ commit }) {
      // console.log("tokenLogin");
      return new Promise((resolve, reject) => {
        let send = {
          appCode: store.getters.appCode
        };
        tokenLogin(signData(send))
          .then(response => {
            let userInfo = {
              authUserOrg: response.authUserOrg || [],
              authUser: response.authUser || [],
              authFuncs: response.authFuncs || [],
              authApps: response.authApps || [],
              orgModel: response.orgModel || [],
              authThirdSsoInfo: response.authThirdSsoInfo || []
            };
            // console.log("userInfo", this.userInfo);
            commit("SET_USER_INFO", userInfo); //保存用户信息
            commit("SET_USER_TYPE", response.userType);
            // setToken(res.token)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // login({commit}, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     setToken("tokenStr");
    //     commit("SET_TOKEN", "tokenStr");
    //     resolve(true);
    //   });
    // },

    // 前端 登出
    logOut({ commit }) {
      return new Promise(resolve => {
        // console.log("9898989");
        var userInfo = store.getters.userInfo;
          commit("SET_TOKEN", "");
          commit("SET_TokenExpriedMins", "");
          commit("SET_RefreshToken", "");
          commit("SET_RefreshTokenExpriedMins", "");
          commit("SET_USER_INFO", {}); //保存用户信息
          // console.log("userInfo", userInfo);
        if( userInfo !== undefined &&
          userInfo.authUser !== null &&
          userInfo.authUser != undefined &&
          userInfo.authUser.thirdSsoFlag != 1){
          removeStorage();
          location.reload();
        }
        if (
          userInfo !== undefined &&
          userInfo.authThirdSsoInfo !== null &&
          userInfo.authThirdSsoInfo != undefined &&
          userInfo.authUser.thirdSsoFlag == 1 &&
          userInfo.authThirdSsoInfo.thirdSsoLogoutFlag == 1
        ) {
          removeStorage();
          location.href = process.env.SSO_LOGIN_LOGOUT_URL;
        } else if ( 
          userInfo !== undefined &&
          userInfo.authThirdSsoInfo !== null &&
          userInfo.authThirdSsoInfo != undefined &&
          userInfo.authUser.thirdSsoFlag == 1 &&
          userInfo.authThirdSsoInfo.thirdSsoLogoutFlag == 0 &&
          userInfo.authThirdSsoInfo.logoutUrl != undefined &&
          userInfo.authThirdSsoInfo.logoutUrl != null &&
          userInfo.authThirdSsoInfo.logoutUrl != "" 
        ){
          removeStorage();
          location.href = userInfo.authThirdSsoInfo.logoutUrl;
        } else {
          removeStorage();
          location.reload();
        }
        resolve();
      });
    },

    // 刷新token
    refreToken({ commit }) {
      return new Promise((resolve, reject) => {
        let send = {
          appId: store.getters.appCode,
          refreshToken: getRefreshToken()
        };
        refToken(signData(send))
          .then(response => {
            const tokenStr = response.token;
            const tokenExpriedMins = response.invalidTime;
            const refreshToken = response.refreshToken;
            const refreshTokenExpriedMins = response.refreshInvalidTime;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr); //token
            setTokenExpriedMins(tokenExpriedMins);
            commit("SET_TokenExpriedMins", tokenExpriedMins); //token有效期
            setRefreshToken(refreshToken);
            commit("SET_RefreshToken", refreshToken); //刷新token
            setRefreshTokenExpriedMins(refreshTokenExpriedMins);
            commit("SET_RefreshTokenExpriedMins", refreshTokenExpriedMins); //刷新token有效期

            // let userInfo = {
            //   authOrg: response.authOrg || [],
            //   authUser: response.authUser || [],
            //   authFuncs: response.authFuncs || [],
            //   authApps: response.authApps || [],
            // }
            // // setUserInfo(userInfo);
            // commit('SET_USER_INFO', userInfo)    //保存用户的所有信息
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 前端 登出
    token_utl({ commit }, send) {
      return new Promise(resolve => {
        setToken(send.token);
        commit("SET_TOKEN", send.token);
        setRefreshToken(send.refreshToken);
        commit("SET_RefreshToken", send.refreshToken);    //刷新token
        resolve();
      });
    },
    // 获取用户信息
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        let send = {
          appId: store.getters.appCode
        };
        getInfo(signData(send))
          .then(response => {
            let userInfo = {
              authUserOrg: response.authUserOrg || [],
              authUser: response.authUser || [],
              authFuncs: response.authFuncs || [],
              authApps: response.authApps || [],
              orgModel: response.orgModel || [],
              authThirdSsoInfo: response.authThirdSsoInfo || []
            };

            commit("SET_USER_INFO", userInfo); //保存用户信息
            commit("SET_USER_TYPE", response.userType);
            // setToken(res.token)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 保存loginSource
    storeLoginSource({ commit }, loginSource) {
      return new Promise(resolve => {
        storeLoginSource(loginSource);
        commit("SET_LOGIN_SOURCE", loginSource);
        resolve();
      });
    },
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js